/* 孫堅傳・第 1 章：西華（汝南郡，184 年）
 * 西邊是朱儁的漢軍營（下邳募來的鄉里少年在此集結），東邊是汝南黃巾的大營。
 * 中間一條汝水的支流由北向南流，主路上有橋、上下游各一處渡口；
 * 北邊是岩丘，南邊是村落與農田，東南的西華一帶是大片高草叢（孫堅落馬、臥草中之處）。 */
export default {
  id: 'xihua', name: '西華', W: 10800, H: 7600, seed: 184,
  bases: [[1000, 4300], [9800, 2900]], // 漢軍營、黃巾大營
  roads: [
    { pts: [[1000, 4300], [2500, 4050], [3700, 4250], [4700, 4500], [5500, 4380], [6600, 4050], [7700, 3600], [8800, 3150], [9800, 2900]], w: 170 }, // 主路：漢軍營 → 橋 → 黃巾大營
    { pts: [[2500, 4050], [2900, 3100], [3300, 2200], [3700, 1600]], w: 120 }, // 北路：往北邊村落
    { pts: [[3700, 4250], [3900, 5300], [4300, 6200], [4700, 6600]], w: 120 }, // 南路：往南邊村落
    { pts: [[6600, 4050], [7100, 5000], [7700, 5900], [8500, 6500]], w: 110 }, // 東南小路：往西華的草野
    { pts: [[7700, 3600], [8000, 2600], [8300, 1800]], w: 100 }, // 黃巾前哨
  ],
  rivers: [
    { pts: [[5600, 100], [5250, 1300], [5650, 2500], [5350, 3600], [5500, 4450], [5900, 5500], [5600, 6600], [5800, 7600]], hw: 150, fords: [[5330, 1500, 230], [5880, 5900, 230]] },
  ],
  rocks: [
    [7000, 900, 700, 300], [8400, 700, 650, 280], [9700, 1100, 520, 360], [6400, 1700, 300, 200], // 北邊的岩丘
    [1700, 1500, 420, 260], [900, 2400, 300, 220], // 西北
    [2100, 6700, 520, 260], [1000, 6100, 300, 200], // 西南
    [7300, 2300, 260, 160], [9400, 4600, 380, 220], [4500, 2900, 220, 150], // 散落的岩塊
  ],
  woods: 0.45,
  sight: 0.65, // 視野倍率：比赤壁短，畫面邊緣是暗的，要自己走過去才看得到
  clearings: [[4300, 3600, 260], [8700, 4100, 300]],
  fields: [
    [3200, 1250, 640, 340], [4250, 1650, 480, 320], [2700, 1900, 420, 260, '#86803f'], // 北村的田
    [3700, 6350, 620, 300], [5000, 6900, 520, 280, '#86803f'], [3200, 5700, 420, 260], // 南村的田
    [1700, 4950, 720, 340], [1900, 3500, 520, 300, '#86803f'], // 漢軍營旁的屯田
  ],
  villages: [{ x: 3700, y: 1500, n: 7, r: 480 }, { x: 4500, y: 6400, n: 6, r: 440 }, { x: 8900, y: 5300, n: 7, r: 500 }], // 北村、南村、西華
  shops: [[3900, 1450], [4300, 6500], [8900, 5300]], // 北村、南村、西華村的商舖（殺敵得來的錢在這裡花）
  tents: [{ x: 9800, y: 2900, n: 12, r: 520, chief: true }, { x: 8300, y: 1800, n: 5, r: 300, chief: true }, { x: 7300, y: 3200, n: 4, r: 260 }],
  marsh: [[6300, 6700, 480, 220], [4900, 3150, 240, 130], [6500, 2800, 280, 140]],
  grass: [
    [7900, 6300, 520, 230], [8700, 6000, 380, 190], [7400, 6800, 420, 170], [8400, 6900, 360, 150], // 西華的草野
    [3000, 4700, 260, 110], [6300, 3500, 300, 140], [9100, 3900, 280, 130], [2200, 3000, 240, 110],
    [4800, 5400, 260, 120], [6900, 4700, 240, 110], [2600, 5600, 260, 120], [7600, 2000, 220, 110],
    [8720, 1500, 200, 95], // 渠帥營後的草叢：隱身摸到渠帥身後
  ],
  // 配樂：商調五聲（D E G A C），比赤壁的曲子低、慢；平靜時塤聲與遠處的心跳鼓，戰鬥時黃巾軍的大鼓與鑼。
  // 「黃天」的動機取自「蒼天已死，黃天當立」四字一頓的口號節奏
  music: {
    name: '西華',
    steps: [0, 2, 5, 7, 10],
    keys: [0, -2, -5],
    bpm: { calm: [58, 66], battle: [92, 104] },
    leads: { calm: ['xun', 'xun', 'flute'], battle: ['pluck', 'both'] },
    drums: 'war',
    pieces: {
      calm: [
        { name: '汝水', mel: [
          [[5, 2], [6, 1], [7, 1]], [[8, 3], [7, 1]], [[6, 1.5], [5, 0.5], [3, 2]], [[5, 3], [null, 1]],
          [[7, 1], [8, 1], [10, 2]], [[9, 1.5], [8, 0.5], [7, 2]], [[6, 1], [5, 1], [6, 1], [3, 1]], [[5, 4]],
        ], roots: [0, 2, 1, 0, 3, 1, 4, 0] },
        { name: '草莽', mel: [
          [[3, 3], [null, 1]], [[5, 1], [4, 1], [3, 2]], [[null, 2], [2, 1], [3, 1]], [[0, 4]],
          [[5, 3], [6, 1]], [[7, 2], [6, 1], [5, 1]], [[3, 1.5], [2, 0.5], [3, 2]], [[null, 4]],
        ], roots: [0, 0, 4, 0, 1, 2, 4, 0] },
      ],
      battle: [
        { name: '黃天', mel: [
          [[10, 1], [10, 1], [8, 1], [10, 1]], [[11, 1], [10, 1], [8, 2]], [[10, 1], [10, 1], [8, 1], [7, 1]], [[5, 2], [7, 2]],
          [[10, 0.5], [10, 0.5], [10, 1], [12, 1], [11, 1]], [[10, 1], [8, 1], [7, 2]], [[8, 0.5], [8, 0.5], [7, 0.5], [5, 0.5], [7, 1], [8, 1]], [[10, 4]],
        ], roots: [0, 0, 2, 4, 0, 1, 4, 0] },
        { name: '突圍', mel: [
          [[5, 0.5], [5, 0.5], [7, 0.5], [8, 0.5], [10, 1], [8, 1]], [[7, 0.5], [8, 0.5], [10, 0.5], [11, 0.5], [12, 2]], [[11, 0.5], [10, 0.5], [8, 0.5], [7, 0.5], [8, 1], [7, 1]], [[5, 2], [null, 1], [5, 1]],
          [[8, 1], [10, 0.5], [11, 0.5], [12, 1], [10, 1]], [[11, 1], [10, 1], [8, 2]], [[7, 0.5], [8, 0.5], [7, 0.5], [5, 0.5], [7, 1], [8, 1]], [[5, 4]],
        ], roots: [0, 2, 4, 0, 1, 2, 4, 0] },
      ],
    },
  },
};
